import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BodyComponent } from "./components/body/body.component";
import { DocumentListComponent } from "./components/document-list/document-list.component";
import { DocumentEditComponent } from "./components/document-edit/document-edit.component";
import { VersionHistoryComponent } from "./components/version-history/version-history.component";
import { VersionViewComponent } from "./components/version-view/version-view.component";

export const staticFileManagerRoutes: Routes = [
  {
    path: 'manager',
    component: BodyComponent,
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      { path: 'overview', component: DocumentListComponent },
      { path: 'new/:documentType', component: DocumentEditComponent },
      { path: 'edit/:documentId', component: DocumentEditComponent },
      { path: 'documents/:documentId/versions', component: VersionHistoryComponent },
      { path: 'versions/:versionId', component: VersionViewComponent },
      { path: '**', redirectTo: 'overview' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(staticFileManagerRoutes)],
  exports: [RouterModule],
})
export class StaticFileManagerRoutingModule {}